
import React from "react";
import { Link } from "react-router-dom";
import { Image } from "cms/image/image";

const StoryResultItem = (props) => {

    const { model } = props;
    const { title, path, description } = model || {};

    return (
        <div className="simplicity-story-item">
            {/*  Banner Image  */}
            <div className="views-field views-field-field-banner-image">
                <div className="field-content banner-image-style">
                    <Image model={model} />
                </div>
            </div>

            <div className="views-field views-field-content">
                {/*  Title / Link  */}
                <div className="simplicity-story-item-title">
                    <h3 className="field-content">
                        <Link to={path}>{title}</Link>
                    </h3>
                </div>

                {/*  Story Summary  */}
                <div className="views-field views-field-body">
                    <div className="field-content">
                        <p>{description}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export { StoryResultItem };
